/**
 * @prettier
 * @flow
 */
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { translate } from 'src/utils/translate/translate';

export function InvalidPaymentLink() {
    const classes = useStyles();
    return (
        <Grid container direction='row' justify='center' alignItems='center' className={classes.container}>
            <div className={classes.paper}>
                <Typography variant='h4' align='center' color='textSecondary'>
                    {translate('Payment link not found')}
                </Typography>
                <Typography variant='subtitle1' align='center' className={classes.header} color='textSecondary'>
                    {translate('Failed to load payment link. Check your url.')}
                </Typography>
            </div>
        </Grid>
    );
}

const useStyles = makeStyles(theme => ({
    container: {
        height: '100%',
    },
}));
